
import {
  EVENTS_UNREAD_SUCCESS,
} from '../../actions/events/unread';

import {
  EVENT_CHANGE,
  EVENT_CHANGE_ALL,
} from '../../actions/events';

import {
  WS_EVENT_NEW,
  WS_EVENT_STATUS,
} from '../../actions/websockets';

const defaultState = {
  result: 'none',
  count: 0,
  events: [],
};

export default function reducer(state = defaultState, action) {
  if (action.type === EVENTS_UNREAD_SUCCESS) {
    return { ...defaultState, ...action.payload };
  }

  if (action.type === EVENT_CHANGE && action.payload.read) {
    return {
      ...state,
      events: state.events.filter(event => (event.id !== action.payload.id)),
      count: state.count > 0 ? state.count - 1 : 0,
    };
  }

  if (action.type === EVENT_CHANGE_ALL && action.payload.status.read) {
    if (action.payload.filter) {
      let { count } = state;
      const events = action.payload.filter.student_id
        // фильтр по студентам
        ? state.events.reduce((arr, item) => {
          if (item.subject_id !== action.payload.filter.student_id) {
            arr.push(item);
          } else {
            count -= 1;
          }
          return arr;
        }, [])
        // фильтр по принадлежности к аккаунту
        : state.events.reduce((arr, item) => {
          if (!item.account_event) {
            arr.push(item);
          } else {
            count -= 1;
          }
          return arr;
        }, []);
      return {
        ...state,
        events,
        count: count > 0 ? count : 0,
      };
    }
    return {
      ...state,
      events: [],
      count: 0,
    };
  }

  // добавление нового события из websokets (только непрочитанного)
  if (
    action.type === WS_EVENT_NEW
    && !action.payload.read
    && !state.events.some(event => (event.id === action.payload.id)) // искл. дубл.
  ) {
    return {
      ...state,
      events: [action.payload, ...state.events],
      count: state.count + 1,
    };
  }

  // измнение статуса события из websokets (на 'прочитанно')
  if (action.type === WS_EVENT_STATUS && action.payload.read) {

    const newEvents = state.events.filter(({ id }) => id !== action.payload.id);
    const concur = state.events.length - newEvents.length;

    return {
      ...state,
      events: newEvents,
      count: (state.count - concur) > 0 ? state.count - concur : 0,
    };
  }

  return state;
}
